"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChronosApi = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var jsonwebtoken_1 = __importDefault(require("jsonwebtoken"));
var api_1 = __importStar(require("./api"));
var payments_1 = require("./payments");
var settings_1 = require("./settings");
var ChronosApi = (function (_super) {
    __extends(ChronosApi, _super);
    function ChronosApi(host, authHost, product, placeHost) {
        var _this = _super.call(this, host) || this;
        _this.feedbackPath = '/api/indi/product/kind/person/feedback';
        _this._authHost = authHost;
        _this._product = product;
        _this._placeHost = placeHost;
        return _this;
    }
    ChronosApi.prototype.showError = function (text) { };
    ChronosApi.prototype.onUpdateShortForms = function (forms) {
        return forms;
    };
    ChronosApi.prototype.onUpdateAuth = function (auth) {
    };
    ChronosApi.prototype.authQuery = function (path, data, method) {
        return __awaiter(this, void 0, void 0, function () {
            var headers;
            var _this = this;
            return __generator(this, function (_a) {
                headers = {
                    "Content-Type": "application/json;charset=utf-8",
                    "Accept": 'application/json',
                };
                return [2, fetch("".concat(this._authHost).concat(path), {
                        method: method,
                        headers: headers,
                        mode: 'cors',
                        credentials: 'include',
                        body: JSON.stringify(data)
                    })
                        .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2, response.ok ? response : Promise.reject(response)];
                        });
                    }); })
                        .then(function (response) {
                        return response.json();
                    })
                        .catch(function (response) { return __awaiter(_this, void 0, void 0, function () {
                        var error, _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    _a = [{}];
                                    return [4, response.json()];
                                case 1:
                                    error = __assign.apply(void 0, [__assign.apply(void 0, _a.concat([_b.sent()])), { status: response.status, statusText: response.statusText }]);
                                    throw error;
                            }
                        });
                    }); })];
            });
        });
    };
    ChronosApi.prototype.refreshIndi = function () {
        window.localStorage.removeItem('token');
        location.reload();
    };
    ChronosApi.prototype.goToAuth = function (weak, lang) {
        if (weak === void 0) { weak = false; }
        if (lang === void 0) { lang = ''; }
        var origin = window.location.origin;
        var hasShared = /shared/.test(window.location.pathname);
        if (origin.includes('indi.chronos.mg') && !hasShared) {
            this.refreshIndi();
            return;
        }
        var sp = new URLSearchParams(window.location.search);
        var isFromMap = location.pathname === '/instruments';
        var pathname = location.pathname;
        if (weak) {
            sp.append('weak', weak.toString());
        }
        if (lang) {
            sp.append('lang', lang);
        }
        sp.delete('token');
        sp.delete('refreshToken');
        sp.delete('redirect');
        var spString = sp.toString();
        sp.append('ref', "".concat(location.protocol, "//").concat(location.host).concat(pathname).concat(spString ? "?".concat(spString) : ''));
        location.href = "".concat(this._authHost, "/#/?").concat(sp.toString());
    };
    ChronosApi.prototype.handleResponse = function (path, opts, _a) {
        var _b;
        var failed = _a.failed, data = _a.data;
        return __awaiter(this, void 0, void 0, function () {
            var errors, auth, err_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!failed) return [3, 9];
                        console.log('Fetch failed:', path, data);
                        errors = data;
                        if (!((errors === null || errors === void 0 ? void 0 : errors.includes('UNAUTHORIZED')) || (errors === null || errors === void 0 ? void 0 : errors.includes('INVALID_TOKEN')))) return [3, 7];
                        if (!((_b = this.token) === null || _b === void 0 ? void 0 : _b.refresh)) return [3, 6];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 5, , 6]);
                        return [4, this.refreshToken(this.token.refresh, this._product)];
                    case 2:
                        auth = _c.sent();
                        if (!auth) return [3, 4];
                        this.token = auth.token;
                        this.onUpdateAuth(auth);
                        return [4, this.query(path, opts)];
                    case 3: return [2, _c.sent()];
                    case 4: return [3, 6];
                    case 5:
                        err_1 = _c.sent();
                        console.log("Refresh failed: -", path, data);
                        return [3, 6];
                    case 6: return [3, 8];
                    case 7:
                        if (errors === null || errors === void 0 ? void 0 : errors.includes('ACCOUNT_DELETED')) {
                            this.goToAuth();
                        }
                        _c.label = 8;
                    case 8: throw new api_1.ApiError(errors !== null && errors !== void 0 ? errors : []);
                    case 9: return [2, data];
                }
            });
        });
    };
    ChronosApi.prototype.signIn = function (token, product) {
        return this.queryPOST('/api/auth/login', { token: token, product: product }, {
            'front-service-location': window.location.href
        });
    };
    ChronosApi.prototype.signOut = function (sessionId) {
        return this.queryPOST('/api/auth/logout', { sessionId: sessionId });
    };
    ChronosApi.prototype.refreshToken = function (token, product) {
        return this.queryPOST('/api/auth/refresh', { token: token, product: product });
    };
    ChronosApi.prototype.places = function (input, language) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        url = new URL("".concat(this._placeHost, "/api/places"));
                        if (language)
                            url.searchParams.append('language', language);
                        url.searchParams.append('input', input);
                        return [4, fetch(url.toString())
                                .then(function (response) { return response.json(); })
                                .then(function (_a) {
                                var data = _a.data;
                                return data;
                            })];
                    case 1:
                        result = _a.sent();
                        return [2, result];
                    case 2:
                        err_2 = _a.sent();
                        console.log("GetPlaces failed: -", err_2);
                        throw err_2;
                    case 3: return [2];
                }
            });
        });
    };
    ChronosApi.prototype.place = function (name, id, language) {
        return __awaiter(this, void 0, void 0, function () {
            var url, resp, result, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        url = new URL("".concat(this._placeHost, "/api/places/").concat(id));
                        if (language)
                            url.searchParams.append('language', language);
                        url.searchParams.append('id', id);
                        return [4, fetch(url.toString())];
                    case 1:
                        resp = _a.sent();
                        if (!resp.ok) {
                            throw new Error("INVALID_INPUT! status: ".concat(resp.status));
                        }
                        return [4, resp.json()];
                    case 2:
                        result = _a.sent();
                        return [2, result.data];
                    case 3:
                        err_3 = _a.sent();
                        console.log("GetPlaces failed: -", err_3);
                        throw err_3;
                    case 4: return [2];
                }
            });
        });
    };
    ChronosApi.prototype.placeUpdate = function (place) {
        return this.queryPOST('/api/places/saved', place);
    };
    ChronosApi.prototype.updateAvatar = function (base64) {
        return this.queryPUT('/api/user/avatar', { base64: base64 });
    };
    ChronosApi.prototype.getChangelog = function (rowsPerPage, page) {
        return this.queryGET('/api/changelog', { rowsPerPage: rowsPerPage, page: page });
    };
    ChronosApi.prototype.profile = function () {
        return this.queryGET('/api/user/profile');
    };
    ChronosApi.prototype.updateProfile = function (data) {
        return this.queryPUT('/api/user/profile', data);
    };
    ChronosApi.prototype.subscriptions = function () {
        return this.queryGET('/api/system/subscriptions');
    };
    ChronosApi.prototype.cancelPromocode = function (promoId, data, headers) {
        return this.queryDELETE("/api/promo/".concat(promoId), data, headers);
    };
    ChronosApi.prototype.usePromocode = function (promo, formationId, headers, forUserEmail) {
        return this.queryPOST('/api/promo', { promo: promo, formationId: formationId, forUserEmail: forUserEmail }, headers);
    };
    ChronosApi.prototype.checkPromocode = function (promo, headers, forUserEmail) {
        return this.queryPOST('/api/promo/check', { promo: promo, forUserEmail: forUserEmail }, headers);
    };
    ChronosApi.prototype.profileSettings = function (userId) {
        return this.queryGET("/api/user/settings", { userId: userId });
    };
    ChronosApi.prototype.updateProfileSettings = function (data) {
        return this.queryPUT('/api/user/settings', { data: data });
    };
    ChronosApi.prototype.devplan = function (confirmed, form, language) {
        return this.queryPOST('/api/astro/idp', {
            confirmed: confirmed,
            form: form,
            language: language,
        });
    };
    ChronosApi.prototype.autoprediction = function (confirmed, form, language) {
        var now = (0, dayjs_1.default)();
        return this.queryPOST('/api/astro/ap', {
            confirmed: confirmed,
            form: form,
            date: now.format('DD.MM.YYYY'),
            time: now.format('HH:mm:ss'),
            language: language,
        });
    };
    ChronosApi.prototype.rectification = function (confirmed, form) {
        return this.queryPOST("/api/forms/".concat(form.id, "/rectification"), {
            confirmed: confirmed,
            form: form,
        });
    };
    ChronosApi.prototype.interpretation = function (maps, form, language) {
        return this.queryPOST('/api/astro/interpretation', {
            maps: maps,
            form: form,
            language: language,
        });
    };
    ChronosApi.prototype.updateRectification = function (formId, data) {
        return this.queryPUT("/api/forms/".concat(formId, "/rectification"), { data: data });
    };
    ChronosApi.prototype.selectRectification = function (formId, data) {
        return this.queryGET("/api/forms/".concat(formId, "/rectification"), data);
    };
    ChronosApi.prototype.updateTablePredictionSettings = function (formId, data) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.queryPOST("/api/forms/".concat(formId, "/tablePredictionSettings"), { tablePredictionSettings: data })];
                    case 1:
                        res = _a.sent();
                        return [2, res];
                }
            });
        });
    };
    ChronosApi.prototype.selectTablePredictionSettings = function (formId) {
        return this.queryGET("/api/forms/".concat(formId, "/tablePredictionSettings"));
    };
    ChronosApi.prototype.updateTablePredictionResult = function (formId, data) {
        return this.queryPOST("/api/forms/".concat(formId, "/tablePredictionResult"), { tablePredictionResult: data });
    };
    ChronosApi.prototype.selectTablePredictionResult = function (formId) {
        return this.queryGET("/api/forms/".concat(formId, "/tablePredictionResult"));
    };
    ChronosApi.prototype.closeNotifications = function (data) {
        return this.queryPUT('/api/user/notifications', data);
    };
    ChronosApi.prototype.description = function (category, id) {
        return this.queryGET('/api/map/description', { category: category, id: id });
    };
    ChronosApi.prototype.setLevelOfAstrology = function (value) {
        return this.queryPUT('/api/user/profile/astrologylevel', { value: value });
    };
    ChronosApi.prototype.theme = function () {
        return this.queryGET('/api/user/theme');
    };
    ChronosApi.prototype.updateTheme = function (theme) {
        this.queryPUT('/api/user/theme', { theme: theme });
    };
    ChronosApi.prototype.folders = function () {
        return this.queryGET("/api/folders");
    };
    ChronosApi.prototype.addFolder = function (_a) {
        var title = _a.title, color = _a.color, is_pinned = _a.is_pinned;
        return this.queryPOST("/api/folders", { title: title, color: color, is_pinned: is_pinned });
    };
    ChronosApi.prototype.updateFolder = function (id, _a) {
        var title = _a.title, color = _a.color, is_pinned = _a.is_pinned;
        return this.queryPUT("/api/folders/".concat(id), { title: title, color: color, is_pinned: is_pinned });
    };
    ChronosApi.prototype.deleteFolder = function (id) {
        return this.queryDELETE("/api/folders/".concat(id));
    };
    ChronosApi.prototype.labels = function () {
        return this.queryGET("/api/labels");
    };
    ChronosApi.prototype.addLabel = function (_a) {
        var title = _a.title, color = _a.color;
        return this.queryPOST("/api/labels", { title: title, color: color });
    };
    ChronosApi.prototype.updateLabel = function (id, _a) {
        var title = _a.title, color = _a.color;
        return this.queryPUT("/api/labels/".concat(id), { title: title, color: color });
    };
    ChronosApi.prototype.deleteLabel = function (id) {
        return this.queryDELETE("/api/labels/".concat(id));
    };
    ChronosApi.prototype.forms = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.queryGET('/api/forms')];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    ChronosApi.prototype.form = function (id, housesSystem) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.queryGET("/api/forms/".concat(id), housesSystem)];
                    case 1:
                        res = _a.sent();
                        return [2, res];
                }
            });
        });
    };
    ChronosApi.prototype.addForm = function (f) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, id, forms;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, this.queryPOST('/api/forms', f)];
                    case 1:
                        _a = _b.sent(), id = _a.id, forms = _a.forms;
                        return [2, {
                                id: id,
                                forms: this.onUpdateShortForms(forms)
                            }];
                }
            });
        });
    };
    ChronosApi.prototype.deleteForm = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.onUpdateShortForms;
                        return [4, this.queryDELETE("/api/forms/".concat(id))];
                    case 1: return [2, _a.apply(this, [_b.sent()])];
                }
            });
        });
    };
    ChronosApi.prototype.updateForm = function (f) {
        return __awaiter(this, void 0, void 0, function () {
            var form;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.queryPUT("/api/forms/".concat(f.id), f)];
                    case 1:
                        form = (_a.sent()).form;
                        return [2, {
                                form: form
                            }];
                }
            });
        });
    };
    ChronosApi.prototype.setFormPin = function (id, value) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.onUpdateShortForms;
                        return [4, this.queryPUT("/api/forms/".concat(id, "/pin"), { id: id, value: value })];
                    case 1: return [2, _a.apply(this, [_b.sent()])];
                }
            });
        });
    };
    ChronosApi.prototype.setFormColor = function (id, value) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.onUpdateShortForms;
                        return [4, this.queryPUT("/api/forms/".concat(id, "/color"), { id: id, value: value })];
                    case 1: return [2, _a.apply(this, [_b.sent()])];
                }
            });
        });
    };
    ChronosApi.prototype.updateFormFolder = function (id, folderId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, this.queryPUT("/api/forms/".concat(id, "/folder"), { id: id, folderId: folderId })];
            });
        });
    };
    ChronosApi.prototype.addFormLabel = function (id, labelId) {
        return this.queryPOST("/api/forms/".concat(id, "/labels"), { id: id, labelId: labelId });
    };
    ChronosApi.prototype.deleteFormLabel = function (id, labelId) {
        return this.queryDELETE("/api/forms/".concat(id, "/labels/").concat(labelId));
    };
    ChronosApi.prototype.updateFormAvatar = function (id, base64) {
        return this.queryPOST("/api/forms/".concat(id, "/avatar"), { base64: base64 });
    };
    ChronosApi.prototype.deleteFormAvatar = function (id) {
        return this.queryDELETE("/api/forms/".concat(id, "/avatar"));
    };
    ChronosApi.prototype.getPersonalizationList = function (userId) {
        return this.queryGET('/api/user/customizations', { userId: userId });
    };
    ChronosApi.prototype.setRatingChangelog = function (id, likes, dislikes) {
        return this.queryPUT("/api/changelog/".concat(id, "/rating"), { likes: likes, dislikes: dislikes });
    };
    ChronosApi.prototype.changeLanguage = function (language) {
        var _a, _b;
        if (!((_a = this.token) === null || _a === void 0 ? void 0 : _a.access))
            return;
        var userId = (_b = jsonwebtoken_1.default.decode(this.token.access)) === null || _b === void 0 ? void 0 : _b.id;
        if (!userId)
            return;
        return this.authQuery("/api/user/".concat(userId, "/language"), { language: language }, 'PUT');
    };
    ChronosApi.prototype.astroSettings = function (userId) {
        return __awaiter(this, void 0, void 0, function () {
            var profiles;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.queryGET('/api/user/astrosettings', { userId: userId })];
                    case 1:
                        profiles = _a.sent();
                        return [2, profiles.map(function (p) { return (0, settings_1.unpackAstroSettings)(p); })];
                }
            });
        });
    };
    ChronosApi.prototype.updateAstroSettings = function (settings) {
        return __awaiter(this, void 0, void 0, function () {
            var data, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = (0, settings_1.packAstroSettings)(settings);
                        res = null;
                        if (!(settings.id === -1)) return [3, 2];
                        return [4, this.queryPOST('/api/user/astrosettings', { data: data })];
                    case 1:
                        res = _a.sent();
                        return [3, 4];
                    case 2: return [4, this.queryPUT('/api/user/astrosettings', {
                            id: settings.id,
                            data: data
                        })];
                    case 3:
                        res = _a.sent();
                        _a.label = 4;
                    case 4: return [2, (0, settings_1.unpackAstroSettings)(res)];
                }
            });
        });
    };
    ChronosApi.prototype.updatePersonalizationSettings = function (_a) {
        var id = _a.id, data = _a.data;
        return id === -1 ?
            this.queryPOST('/api/user/customizations', data) :
            this.queryPUT("/api/user/customizations/".concat(id), { data: data });
    };
    ChronosApi.prototype.paymentFullInfo = function () {
        return this.queryGET('/api/user/contract');
    };
    ChronosApi.prototype.paymentList = function () {
        return this.queryGET('/api/user/payments');
    };
    ChronosApi.prototype.autopaymentChange = function (value) {
        return this.queryPUT('/api/user/contract/autopayment', { value: value });
    };
    ChronosApi.prototype.subscriptionChange = function (subs) {
        return this.queryPUT('/api/user/contract', { subscriptions: subs, days: 777 });
    };
    ChronosApi.prototype.payment = function (data, method, opts) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var script, options_1, _c, languages, widgetData_1, handler_1, error_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        script = document.createElement('script');
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 7, , 8]);
                        if (!(data.type === 'widget' || ((_a = data.data) === null || _a === void 0 ? void 0 : _a.type) === 'indi')) return [3, 2];
                        _c = data;
                        return [3, 4];
                    case 2: return [4, this.queryPOST('/api/user/payments/config', data)];
                    case 3:
                        _c = _d.sent();
                        _d.label = 4;
                    case 4:
                        options_1 = _c;
                        languages = {
                            ru: 'ru-RU',
                            kz: 'kk-KZ',
                            us: 'en-US',
                            en: 'en-US'
                        };
                        widgetData_1 = {
                            type: 'tiptop',
                            method: 'Widget',
                            src: 'https://widget.tiptoppay.kz/bundles/widget.js',
                            language: languages[data.country]
                        };
                        if (data.country === payments_1.EPaymentCountry.ru) {
                            widgetData_1 = {
                                type: 'cp',
                                method: 'CloudPayments',
                                src: 'https://widget.cloudpayments.ru/bundles/cloudpayments',
                                language: data.country
                            };
                        }
                        return [4, new Promise(function (resolve, reject) {
                                document.head.append(script);
                                script.onload = resolve;
                                script.onerror = reject;
                                script.async = true;
                                script.src = widgetData_1.src;
                            })];
                    case 5:
                        _d.sent();
                        handler_1 = new ((_b = window[widgetData_1.type]) === null || _b === void 0 ? void 0 : _b[widgetData_1.method])({ language: widgetData_1.language });
                        if (options_1 === null || options_1 === void 0 ? void 0 : options_1.data) {
                            options_1.data.comment = data.comment;
                        }
                        return [4, new Promise(function (resolve, reject) {
                                handler_1[method](options_1, function (data) {
                                    var _a;
                                    (_a = opts === null || opts === void 0 ? void 0 : opts.onSuccess) === null || _a === void 0 ? void 0 : _a.call(opts, data);
                                    resolve(data);
                                }, function (err) {
                                    var _a;
                                    (_a = opts === null || opts === void 0 ? void 0 : opts.onCancel) === null || _a === void 0 ? void 0 : _a.call(opts, err);
                                    reject(err);
                                });
                            })];
                    case 6:
                        _d.sent();
                        script.remove();
                        return [2, {
                                failed: false,
                            }];
                    case 7:
                        error_1 = _d.sent();
                        console.error("Payment error: ".concat(error_1));
                        script.remove();
                        return [2, {
                                failed: true,
                                error: error_1,
                            }];
                    case 8: return [2];
                }
            });
        });
    };
    ChronosApi.prototype.workDatabase = function (opts) {
        var _a;
        var q = [];
        if ((_a = opts === null || opts === void 0 ? void 0 : opts.keys) === null || _a === void 0 ? void 0 : _a.length) {
            q.push("keys=".concat(opts.keys.join(',')));
        }
        if (opts === null || opts === void 0 ? void 0 : opts.showHidden) {
            q.push('showHidden');
        }
        if (opts === null || opts === void 0 ? void 0 : opts.language) {
            q.push('language=' + (opts === null || opts === void 0 ? void 0 : opts.language));
        }
        return this.queryGET("/api/work".concat(q.length ? "?".concat(q.join('&')) : ''));
    };
    ChronosApi.prototype.workProfiles = function (query) {
        var q = (0, api_1.getQuery)(query);
        return this.queryGET("/api/work/profiles?".concat(q));
    };
    ChronosApi.prototype.workProfile = function (userId, formats) {
        return this.queryGET("/api/work/profiles/".concat(userId).concat(formats ? "/formats=".concat(formats) : ''));
    };
    ChronosApi.prototype.updateProfileNew = function (userId, profile, avatarBase64) {
        return this.queryPUT("/api/work/profiles/".concat(userId, "/profile"), {
            profile: profile,
            avatarBase64: avatarBase64
        });
    };
    ChronosApi.prototype.updateWorkProfileData = function (userId, data) {
        return this.queryPUT("/api/work/profiles/".concat(userId), data);
    };
    ChronosApi.prototype.updateWorkProfileSchedule = function (userId, data) {
        return this.queryPUT("/api/work/profiles/".concat(userId, "/schedule"), data);
    };
    ChronosApi.prototype.updateUserServices = function (userId, services) {
        return this.queryPUT("/api/work/profiles/".concat(userId, "/services"), { services: services });
    };
    ChronosApi.prototype.userSessions = function (userId, opts) {
        var q = (0, api_1.getQuery)(opts);
        return this.queryGET("/api/work/profiles/".concat(userId, "/sessions").concat(q ? "?".concat(q) : ''));
    };
    ChronosApi.prototype.getSessions = function (opts) {
        var q = (0, api_1.getQuery)(opts);
        return this.queryGET("/api/work/sessions".concat(q ? "?".concat(q) : ''));
    };
    ChronosApi.prototype.getSession = function (id) {
        return this.queryGET("/api/work/sessions/".concat(id));
    };
    ChronosApi.prototype.addSession = function (data) {
        return this.queryPOST('/api/work/sessions', data);
    };
    ChronosApi.prototype.updateSession = function (sessionId, data) {
        return this.queryPUT("/api/work/sessions/".concat(sessionId), data);
    };
    ChronosApi.prototype.cancelSession = function (sessionId) {
        return this.queryDELETE("/api/work/sessions/".concat(sessionId));
    };
    ChronosApi.prototype.sessionChanges = function (data) {
        return this.queryPOST("/api/work/sessions/changes", data);
    };
    ChronosApi.prototype.getSessionMeeting = function (sessionId) {
        return this.queryGET("/api/work/sessions/".concat(sessionId, "/meeting"));
    };
    ChronosApi.prototype.updateSessionMeeting = function (sessionId) {
        return this.queryPUT("/api/work/sessions/".concat(sessionId, "/meeting"), {});
    };
    ChronosApi.prototype.uploadSessionDocuments = function (sessionId, data) {
        return this.queryPUT("/api/work/sessions/".concat(sessionId, "/documents"), data);
    };
    ChronosApi.prototype.removeSessionDocument = function (sessionId, data) {
        return this.queryDELETE("/api/work/sessions/".concat(sessionId, "/documents"), data);
    };
    ChronosApi.prototype.scheduleSlots = function (userId, opts) {
        var q = (0, api_1.getQuery)(opts);
        return this.queryGET("/api/work/profiles/".concat(userId, "/slots").concat(q ? "?".concat(q) : ''));
    };
    ChronosApi.prototype.getAllSlots = function (opts) {
        var q = (0, api_1.getQuery)(opts);
        return this.queryGET("/api/work/profiles/slots".concat(q ? "?".concat(q) : ''));
    };
    ChronosApi.prototype.signUp = function (phone) {
        return this.queryPOST('/api/auth/register', { channel: phone, type: 'nopass' });
    };
    ChronosApi.prototype.signUpConfirm = function (phone, code, captchaToken) {
        return this.queryPOST('/api/auth/confirm', { channel: phone, code: code, captchaToken: captchaToken });
    };
    ChronosApi.prototype.addPartner = function (partner) {
        return this.queryPOST('/api/auth/partner', { partner: partner });
    };
    ChronosApi.prototype.verifyPhoneCode = function (phone, code) {
        return this.queryPOST('/api/auth/channel', { channel: phone, verification: code });
    };
    ChronosApi.prototype.verifyPhone = function (phone, token) {
        return this.queryPOST('/api/auth/verify', { channel: phone, token: token });
    };
    ChronosApi.prototype.resendCerification = function (data) {
        return this.queryPOST('/api/auth/resend', data);
    };
    ChronosApi.prototype.workWithdraw = function (opts) {
        return this.queryPOST('/api/user/withdraw', opts);
    };
    ChronosApi.prototype.typeform = function (formId, responseId) {
        return this.queryGET("/api/work/typeform?formId=".concat(formId, "&responseId=").concat(responseId));
    };
    ChronosApi.prototype.getSessionPaymentUrl = function (sessionId, opts) {
        var q = (0, api_1.getQuery)(opts);
        return this.queryGET("/api/work/session/".concat(sessionId, "/payment/url").concat(q ? "?".concat(q) : ''));
    };
    ChronosApi.prototype.payout = function (sessionId, rollback) {
        if (rollback === void 0) { rollback = false; }
        return this.queryPUT("/api/work/session/".concat(sessionId, "/payout"), { rollback: rollback });
    };
    ChronosApi.prototype.getPayoutUrl = function (domain) {
        return this.queryGET("/api/work/profiles/payout/url?domain=".concat(domain));
    };
    ChronosApi.prototype.removeCard = function (cardId, domain) {
        return this.queryPOST('/api/work/profiles/drop/card', { cardId: cardId, domain: domain });
    };
    ChronosApi.prototype.getMeeting = function (sessionId, recreate) {
        if (recreate === void 0) { recreate = false; }
        return this.queryGET("/api/work/sessions/".concat(sessionId, "/meeting").concat(recreate ? '?recreate=true' : ''));
    };
    ChronosApi.prototype.getHoroscope = function (date) {
        return this.queryGET("/api/horoscope?date=".concat(date));
    };
    ChronosApi.prototype.getPartnerDiscount = function (target, partner) {
        return this.queryGET("/api/user/partner/discount?target=".concat(target).concat(partner ? "&partner=".concat(partner) : ''));
    };
    ChronosApi.prototype.getSubscriptions = function (opts) {
        var q = (0, api_1.getQuery)(opts);
        return this.queryGET("/api/user/subscribe".concat(q ? "?".concat(q) : ''));
    };
    ChronosApi.prototype.subscribe = function (opts) {
        return this.queryPOST("/api/user/subscribe", opts);
    };
    ChronosApi.prototype.getCourses = function () {
        return this.queryGET("/api/courses");
    };
    ChronosApi.prototype.getCourse = function (courseId) {
        return this.queryGET("/api/courses/".concat(courseId));
    };
    ChronosApi.prototype.getTariffs = function () {
        return this.queryGET('/api/tariffs');
    };
    ChronosApi.prototype.sessionSupportSend = function (sessionId, data) {
        return this.queryPOST("/api/work/sessions/".concat(sessionId, "/support"), data);
    };
    ChronosApi.prototype.shareFormation = function (id) {
        return this.queryPUT("/api/formations/".concat(id, "/share"), {});
    };
    ChronosApi.prototype.checkFormation = function (hash) {
        return this.queryGET("/api/formations/check/hash", { hash: hash });
    };
    ChronosApi.prototype.indiGetAdminPageInfo = function () {
        return this.queryGET("/api/indi/admin-page-info", {});
    };
    ChronosApi.prototype.indiPutAdminPageInfo = function (data) {
        return this.queryPUT("/api/indi/admin-page-info", data);
    };
    ChronosApi.prototype.indiGetSynastry = function (data, headers) {
        return this.queryGET("/api/indi/product/kind/synastry/".concat(data.purchasedSynastryId), undefined, headers);
    };
    ChronosApi.prototype.indiGetProducts = function (data) {
        return this.queryGET('/api/indi/product/catalog', { currencyCode: data.currencyCode });
    };
    ChronosApi.prototype.indiGetPurchasedProducts = function () {
        return this.queryGET('/api/indi/product/purchased');
    };
    ChronosApi.prototype.indiGetPaymentConfig = function (data, headers) {
        return this.queryPOST('/api/indi/payment/config', data, headers);
    };
    ChronosApi.prototype.indiIsProductPaid = function (data) {
        return this.queryPOST('/api/indi/product/is-paid', data);
    };
    ChronosApi.prototype.indiGetSharedSynastry = function (data, headers) {
        return this.queryGET("/api/indi/product/shared/synastry/".concat(data.token), undefined, headers);
    };
    ChronosApi.prototype.indiGetSynastryShareToken = function (data) {
        return this.queryGET("/api/indi/product/token/synastry/".concat(data.synastryId));
    };
    ChronosApi.prototype.indiCalculateFreeSynastry = function (data, headers) {
        return this.queryPOST("/api/indi/product/kind/synastry/free", data, headers);
    };
    ChronosApi.prototype.indiGetTrialSynastry = function (data, headers) {
        return this.queryPOST("/api/indi/product/kind/synastry/trial", data, headers);
    };
    ChronosApi.prototype.setUserRegion = function (data) {
        return this.queryPOST("/api/user-region/set", data);
    };
    ChronosApi.prototype.getUserRegion = function () {
        return this.queryGET("/api/user-region");
    };
    ChronosApi.prototype.getRegion = function () {
        return this.queryGET("/api/region");
    };
    ChronosApi.prototype.indiGetEmotions = function (data) {
        return this.queryGET("/api/indi/product/kind/emotions/".concat(data.purchasedEmotionsId));
    };
    ChronosApi.prototype.indiGetSharedEmotions = function (data) {
        return this.queryGET("/api/indi/product/shared/emotions/".concat(data.token));
    };
    ChronosApi.prototype.indiGetEmotionsShareToken = function (data) {
        return this.queryGET("/api/indi/product/token/emotions/".concat(data.emotionsId));
    };
    ChronosApi.prototype.getPrognosesFeed = function (data) {
        return this.queryGET("/api/prognosis/feed?date=".concat(data.date).concat(data.to ? "&to=".concat(data.to) : "", "&gmt=").concat(data.gmt));
    };
    ChronosApi.prototype.setPrognosesFeedback = function (data) {
        return this.queryPOST('/api/prognosis/feedback', data);
    };
    ChronosApi.prototype.indiCalculateFreeEmotions = function (data, headers) {
        return this.queryPOST("/api/indi/product/kind/emotions/free", data, headers);
    };
    ChronosApi.prototype.indiGetSolar = function (data) {
        return this.queryGET("/api/indi/product/kind/solar/".concat(data.purchasedSolarId));
    };
    ChronosApi.prototype.indiGetPersonDescription = function (data) {
        return this.queryGET("/api/indi/product/kind/person/".concat(data.purchasedId));
    };
    ChronosApi.prototype.indiGetPersonFeedbackByUser = function () {
        return this.queryGET(this.feedbackPath + '/user');
    };
    ChronosApi.prototype.indiGetPersonFeedbackById = function (data) {
        return this.queryGET("".concat(this.feedbackPath, "/").concat(data.feedbackId));
    };
    ChronosApi.prototype.indiAddPersonFeedback = function (data) {
        return this.queryPOST("".concat(this.feedbackPath), data);
    };
    ChronosApi.prototype.indiDeletePersonFeedback = function (data) {
        return this.queryDELETE("".concat(this.feedbackPath, "/").concat(data.feedbackId), data);
    };
    ChronosApi.prototype.indiGetSharedSolar = function (data) {
        return this.queryGET("/api/indi/product/shared/solar/".concat(data.token));
    };
    ChronosApi.prototype.indiGetSolarShareToken = function (data) {
        return this.queryGET("/api/indi/product/token/solar/".concat(data.solarId));
    };
    ChronosApi.prototype.indiCalculateFreeSolar = function (data, headers) {
        return this.queryPOST("/api/indi/product/kind/solar/free", data, headers);
    };
    ChronosApi.prototype.indiUpdateSolar = function (data) {
        return this.queryPOST("/api/indi/product/update/solar/date", data);
    };
    ChronosApi.prototype.indiSignUpWithEmail = function (data) {
        return this.queryPOST("/api/auth/email/signup", data);
    };
    ChronosApi.prototype.indiSignUpOrSignInWithEmail = function (data) {
        return this.authQuery("/api/auth/autherticate-or-register", data, 'POST');
    };
    ChronosApi.prototype.indiGetEvents = function (opts, startPlan, endPlan, now) {
        var q = (0, api_1.getQuery)(opts);
        return this.queryGET("/api/indi/events?".concat(q, "&startPlan=").concat(startPlan, "&endPlan=").concat(endPlan, "&now=").concat(now));
    };
    ChronosApi.prototype.indiGetMonth = function (startPlan, endPlan, now) {
        return this.queryGET("/api/indi/events/month?startPlan=".concat(startPlan, "&endPlan=").concat(endPlan, "&now=").concat(now));
    };
    ChronosApi.prototype.indiUnsubscribe = function (data) {
        return this.queryPUT("/api/indi/contracts", data);
    };
    ChronosApi.prototype.indiGetTariffs = function (country) {
        return this.queryGET("/api/indi/tariffs?country=".concat(country));
    };
    ChronosApi.prototype.indiTrialGetAction = function (email) {
        return this.queryGET("/api/indi/trial?email=".concat(email));
    };
    ChronosApi.prototype.indiActivateTrial = function (email) {
        return this.queryPOST("/api/user/activate-indi-trial", {
            email: email
        });
    };
    ChronosApi.prototype.indiActivateTrialForTest = function (userId, email) {
        return this.queryPOST("/api/indi/activate/trial", {
            userId: userId,
            email: email
        });
    };
    ChronosApi.prototype.cb = function (_a) {
        var conversion = _a.conversion;
        return this.authQuery("/api/auth/cb", { conversion: conversion }, 'POST');
    };
    ChronosApi.prototype.signInWithEmail = function (_a) {
        var email = _a.email, password = _a.password;
        return this.queryPOST("/api/auth/email/signin", { email: email, password: password });
    };
    ChronosApi.prototype.authenticateWithPhone = function (phone, token, addition) {
        return this.queryPOST("/api/auth/phone/authenticate", { phone: phone, token: token, addition: addition });
    };
    ChronosApi.prototype.restorePassword = function (data) {
        return this.authQuery("/api/password/restore", data, 'POST');
    };
    ChronosApi.prototype.restorePasswordConfirm = function (data) {
        return this.authQuery("/api/password/restore/confirm", data, 'POST');
    };
    ChronosApi.prototype.changePassword = function (data) {
        return this.authQuery("/api/password/change", data, 'POST');
    };
    ChronosApi.prototype.orderRectification = function (data) {
        return this.queryPOST("/api/indi/rectifications", data);
    };
    ChronosApi.prototype.sendFeedback = function (data) {
        return this.queryPOST("/api/indi/events/feedback", data);
    };
    ChronosApi.prototype.sendNotify = function (message, context) {
        return this.queryPOST("/api/misc/notify", {
            message: message,
            context: context || {}
        });
    };
    ChronosApi.prototype.sendTimeLoadNotify = function (data, headers) {
        return this.queryPOST("/api/misc/time-load-notify", data, headers);
    };
    ChronosApi.prototype.createRegistrationLog = function (data) {
        return this.queryPOST("/api/logging/phone/registration", data);
    };
    ChronosApi.prototype.updateRegistrationLog = function (data) {
        return this.queryPUT("/api/logging/phone/registration", data);
    };
    ChronosApi.prototype.getMoon = function (data) {
        return this.queryGET("/api/prognosis/feed/moon?date=".concat(data.date, "&gmt=").concat(data.gmt));
    };
    ChronosApi.prototype.indiUseOffer = function (data) {
        return this.queryPOST("/api/indi/offers", data);
    };
    ChronosApi.prototype.indiGetAstroEvents = function (data) {
        return this.queryGET("/api/prognosis/astro/events".concat(data.date ? "?from=".concat(data.date) : ''));
    };
    ChronosApi.prototype.indiGetNotes = function (userId) {
        return this.queryGET("/api/indi/notes?userId=".concat(userId));
    };
    ChronosApi.prototype.indiAddNote = function (data) {
        return this.queryPOST("/api/indi/notes", data);
    };
    ChronosApi.prototype.indiRemoveNote = function (id) {
        var queryString = id instanceof Array ? id.map(function (id) { return "id=".concat(id); }).join('&') : "id=".concat(id, "}");
        return this.queryDELETE("/api/indi/notes?".concat(queryString));
    };
    ChronosApi.prototype.indiGetRecommendations = function (noteId) {
        var queryString = noteId instanceof Array ? noteId.map(function (id) { return "noteId=".concat(id); }).join('&') : "noteId=".concat(noteId, "}");
        return this.queryGET("/api/indi/notes/recommendations?".concat(queryString));
    };
    ChronosApi.prototype.indiAddRecommendation = function (data) {
        return this.queryPOST("/api/indi/notes/recommendations", data);
    };
    ChronosApi.prototype.indiRemoveRecommendation = function (date) {
        return this.queryDELETE("/api/indi/notes/recommendations?id=".concat(date.id));
    };
    ChronosApi.prototype.createLoggingSession = function (data) {
        return this.queryPOST("/api/logging/session", data);
    };
    ChronosApi.prototype.indiSendMailToSupport = function (data) {
        return this.queryPOST("/api/indi/support", data);
    };
    ChronosApi.prototype.indiGetBanners = function (data) {
        return this.queryGET("/api/indi/".concat(data.userId, "/banners"));
    };
    ChronosApi.prototype.indiPutBanners = function (data) {
        return this.queryPUT("/api/indi/".concat(data.userId, "/banners"), data);
    };
    ChronosApi.prototype.indiPostLeads = function (data) {
        return this.queryPOST("/api/indi/leads", data);
    };
    ChronosApi.prototype.indiWebPushAllow = function (data) {
        return this.queryPUT("/api/wp/".concat(data.userId, "/allow"), data.data);
    };
    ChronosApi.prototype.indiWebPushGetSubscribe = function (userId) {
        return this.queryGET("/api/wp/".concat(userId, "/subscriptions"));
    };
    ChronosApi.prototype.indiWebPushSubscribe = function (data) {
        return this.queryPUT("/api/wp/".concat(data.userId, "/subscriptions"), data.data);
    };
    ChronosApi.prototype.indiWebPushTest = function (userId) {
        return this.queryPOST("/api/wp/".concat(userId, "/test"), { test: 'TEST MESSAGE', body: 'TEST BODY' });
    };
    ChronosApi.prototype.indiWebPushGetModal = function (userId) {
        return this.queryGET("/api/wp/".concat(userId, "/modal"));
    };
    ChronosApi.prototype.indiWebPushPutModal = function (data) {
        return this.queryPUT("/api/wp/".concat(data.userId, "/modal"), data.data);
    };
    ChronosApi.prototype.indiGetTrialWithoutCard = function (data) {
        return this.queryPOST("/api/indi/trial/cardless", data);
    };
    ChronosApi.prototype.indiAddPwaInstallation = function (data) {
        return this.queryPOST("/api/pwa/installed", data);
    };
    ChronosApi.prototype.indiSetUserUsesPwa = function (data) {
        return this.queryPUT("/api/pwa/set_use", data);
    };
    ChronosApi.prototype.indiCalculateFreePerson = function (data) {
        return this.queryPOST("/api/indi/product/kind/person/free", data);
    };
    return ChronosApi;
}(api_1.default));
exports.ChronosApi = ChronosApi;
